import React from 'react';

const Insert = ({service}) => (
    <a href={service.insertURL}><i className="fa fa-plus" aria-hidden="true"></i> 新 增</a>
);

export default Insert;